export default __webpack_public_path__ + "static/media/share-dark.89f75248.svg";